import React from 'react'

export default function ContactSajatUtamonContent() {
  return (
    <>
      <div className="space-y-6 p-6 text-lg">
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-amber-800">8 alkalmas művészetterápiás csoport</h3>
          
          <div className="space-y-3">
           <div className="flex items-start gap-4">
              <svg 
                className="w-16 h-16 flex-shrink-0 mt-1 text-amber-800 opacity-60" 
                viewBox="0 0 93.936 93.936"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M80.179,13.758c-18.342-18.342-48.08-18.342-66.422,0c-18.342,18.341-18.342,48.08,0,66.421
                  c18.342,18.342,48.08,18.342,66.422,0C98.521,61.837,98.521,32.099,80.179,13.758z M44.144,83.117
                  c-4.057,0-7.001-3.071-7.001-7.305c0-4.291,2.987-7.404,7.102-7.404c4.123,0,7.001,3.044,7.001,7.404
                  C51.246,80.113,48.326,83.117,44.144,83.117z M54.73,44.921c-4.15,4.905-5.796,9.117-5.503,14.088l0.097,2.495
                  c0.011,0.062,0.017,0.125,0.017,0.188c0,0.58-0.47,1.051-1.05,1.051c-0.004-0.001-0.008-0.001-0.012,0h-7.867
                  c-0.549,0-1.005-0.423-1.047-0.97l-0.202-2.623c-0.676-6.082,1.508-12.218,6.494-18.202c4.319-5.087,6.816-8.865,6.816-13.145
                  c0-4.829-3.036-7.536-8.548-7.624c-3.403,0-7.242,1.171-9.534,2.913c-0.264,0.201-0.607,0.264-0.925,0.173
                  s-0.575-0.327-0.693-0.636l-2.42-6.354c-0.169-0.442-0.02-0.943,0.364-1.224c3.538-2.573,9.441-4.235,15.041-4.235
                  c12.36,0,17.894,7.975,17.894,15.877C63.652,33.765,59.785,38.919,54.73,44.921z"/>
              </svg>
            <p className="text-justify">
              Ez a csoport azoknak szól, akik keresik a saját útjukat, az is lehet, hogy már úton vannak és lehet az út még bizonytalannak tűnik vagy átmeneti vagy éppen változásban van. Nem kell tudnod, merre tartasz, és nem kell kész válaszokkal érkezned. Elég, ha van benned egy szándék arra, hogy jobban ráláss arra, ami benned zajlik.
            </p></div>
            
            <div className="flex items-start gap-4 mb-12">
              <img 
                src="/images/paint-palette.svg" 
                alt="Festék paletta" 
                className="w-16 h-16 flex-shrink-0 mt-1"
              />
              <p className="text-justify flex-1">
                A művészetterápiás folyamat során az alkotás segít kapcsolódni a belső érzésekhez, gondolatokhoz és kérdésekhez. Nem a rajztudás számít, hanem az, hogy teret adj annak, ami meg szeretne jelenni. A csoport megtartó közege lehetőséget ad arra, hogy több nézőpontból láss rá saját folyamataidra, és megtapasztald: <strong>nem vagy egyedül</strong>.
              </p>
            </div>
            
            <p className="text-justify">
              Ez a csoport nem megoldásokat ígér (bár lehet a megoldás is megjelenik a folyamatodban) hanem figyelmet, időt és teret, amelyben meg lehet állni, el lehet bizonytalanodni, és újra lehet kapcsolódni önmagadhoz. Ha csendesebb, mélyebb önismereti munkára vágysz, és szeretnél egy támogató közegben elindulni a saját utadon, szeretettel várlak.
            </p>
            
            <p className="text-justify font-medium">
              Ahogy a tavalyi márciustól decemberig tartó csoporton, idén is többféle művészetterápiás eszközt is kipróbálhatsz az alkalmakon, így arra is lehetőséged nyílik, hogy új technikákat, eszközöket, alkotási lehetőségeket próbálj ki.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <p className="font-semibold">
              <i className="bi bi-house-door-fill mr-2"></i> Helyszín:
            </p>
            <p>MMSZKE Astoria</p>
            <p>1053 Budapest, Kossuth Lajos u. 17. III. em. 6.</p>
          </div>

          <div className="space-y-2">
            <p className="flex items-center font-semibold">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-calendar mr-2 h-5 w-5">
                <path d="M8 2v4"></path>
                <path d="M16 2v4"></path>
                <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                <path d="M3 10h18"></path>
              </svg>
              Időpontok:
            </p>
            <p className="font-medium">Szombatonként 17:00 – 20:30 (nyári szünettel)</p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 list-none">
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. március 21.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. április 25.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. május 23.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. június 20.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. szeptember 12.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. október 10.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. november 21.</span>
              </li>
              <li className="flex items-center">
                <i className="bi bi-calendar-check mr-2 text-amber-600"></i>
                <span className="text-sm">2026. december 12.</span>
              </li>
            </ul>
          </div>

          <div className="space-y-2">
            <p className="font-semibold">Részvételi díj:</p>
            <p>10.000 Ft/alkalom</p>
            <p className="text-sm italic">
              A díj tartalmazza a terembérlést, a felhasznált eszközöket és egy kis rágcsát is.
            </p>
          </div>

          <div className="space-y-2">
            <p className="font-semibold">Jelentkezési határidő:</p>
            <p>2026. március 16.</p>
          </div>
        </div>
      </div>
    </>
  )
}

